import { useQuery } from '@tanstack/react-query';
import { getReports } from '../services/requests';
import type { ReportsRequest } from '../schemas/auth';

export const useReports = (params?: ReportsRequest) => {
  return useQuery({
    queryKey: ['reports', params],
    queryFn: () => getReports(params),
    enabled: true, // Her zaman çalışacak, params olmasa bile
  });
};
